class APIS {
	apis() {
		return {
			createChannel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/create/channel'
			},
			updateChannel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/update/channel'
			},
			deleteChannel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/delete/channel'
			},
			toggleChannel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/toggle/channel'
			},
			getChannels: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/get/channels'
			},
			channelsAppAdd: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/channel-apps/add'
			},
			channelsAppUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/channel-apps/update'
			},
			channelsAppList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/channel-apps/list'
			},
			channelsAppCredentials: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/channel-apps/credentials'
			},
			channelsAppGet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/channel-apps/get'
			},
			channelsAppToggle: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/channel-apps/toggle'
			},
			clientChannelsAdd: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-channels/add'
			},
			clientChannelsBulkAdd: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-channels/bulk-add'
			},
			clientChannelsUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-channels/update'
			},
			clientChannelsList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-channels/list'
			},
			clientChannelsAll: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-channels/all'
			},
			clientChannelsClientsByChannel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-channels/clients-by-channel'
			},
			clientChannelsCheckAccess: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-channels/check-access'
			},
			clientChannelsToggle: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-channels/toggle'
			},
			clientChannelsApp: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-channels/app'
			},
			whatsappAccountsAdd: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/whatsapp-accounts/add'
			},
			whatsappAccountsUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/whatsapp-accounts/update'
			},
			whatsappAccountsGetAccountsByClientId: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/whatsapp-accounts/list'
			},
			whatsappAccountsGetAllAccounts: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/whatsapp-accounts/all'
			},
			whatsappAccountsToggle: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/whatsapp-accounts/toggle'
			},
			whatsappAccountsUpdateQualityRating: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/whatsapp-accounts/quality-rating'
			},
			whatsappAccountsUpdateMessagingLimits: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/whatsapp-accounts/messaging-limits'
			},
			metaAppAdd: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/meta-apps/add'
			},
			metaAppUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/meta-apps/update'
			},
			metaAppList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/meta-apps/list'
			},
			metaAppGetById: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/meta-apps/get'
			},
			metaAppDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/meta-apps/delete'
			},
			metaAppGetWithChannel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/meta-apps/with-channels'
			},

		};
	}
}

export default new APIS();